import {ChangeDetectorRef, Component, Input} from '@angular/core';
import {DcpOrderEntryService} from '@app/services/dcp-order-entry.service';
import {OrderEntry} from '@spartacus/cart/base/root/models/cart.model';
import {uniqBy} from 'lodash-es';

@Component({
  selector: 'dcp-derivative-entry-list',
  templateUrl: './derivative-entry-list.component.html',
})
export class DerivativeEntryListComponent {

  private _derivativeEntries: OrderEntry[];

  @Input()
  set derivativeEntries(value: OrderEntry[]) {
    this._derivativeEntries = value;
    this.cdr.detectChanges();
  };

  get derivativeEntries(): OrderEntry[] {
    return uniqBy(this._derivativeEntries, 'entryNumber');
  }

  constructor(
    public cdr: ChangeDetectorRef,
    public dcpOrderEntryService: DcpOrderEntryService,
  ) {
  }
}
